export default __webpack_public_path__ + "static/media/DAIF_Services_Screen3_in.46ac04b2.mp4";